import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import styles from "./editview.module.css";
import dayjs from "dayjs";
import axios from "axios";
import { ArrowRight, Calendar2Fill } from "react-bootstrap-icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { LoadingButton } from "@mui/lab";
import Loading from "../../../Components/Loading/Loading";
import {
  filterPaymentMethods,
  getEntityByProperty,
} from "../../../utils/Filters";
import { MobileDatePicker } from "@mui/x-date-pickers";

function EditView() {
  // Utils
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state;
  const [initialLoading, setInitialLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  //Data Fields
  const id = useParams().id;
  const [finalAmount, setFinalAmount] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [type, setType] = useState("");
  const [date, setDate] = useState(null);
  const [userName, setUserName] = useState("");
  const [payment, setPayment] = useState("");
  const [workingTime, setWorkingTime] = useState("");
  const [customTime, setCustomTime] = useState("");
  // const [isReceived, setReceived] = useState(false);
  const [site, setSite] = useState("");
  const [movingSite, setMovingSite] = useState("");
  const [discounted, setDiscounted] = useState(false);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [discountReason, setDiscountReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [amount, setAmount] = useState(0);
  const [paymentOptions, setPaymentOptions] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const role = useSelector((state) => state.auth.role.roleName);

  // Relations
  const [availableViewTypes, setAvailableViewTypes] = useState([]);
  const [availableWorkTimes, setAvailableWorkTimes] = useState([]);
  const [availableUsers, setAvailableUsers] = useState([]);
  const [availableSites, setAvailableSites] = useState([]);
  const [availablePaymentMethods, setAvailablePaymentMethods] = useState([]);
  const [availableDiscountReason, setAvailableDiscountReason] = useState([]);
  const fetchData = useCallback(async () => {
    setInitialLoading(true);
    try {
      const [viewtype, paymentmethod, site, reasons, worktimes] =
        await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/viewType/`, {
            withCredentials: true,
          }),
          axios.get(`${process.env.REACT_APP_API_URL}/paymentmethod/`, {
            withCredentials: true,
          }),
          axios.get(
            `${process.env.REACT_APP_API_URL}/user/${user.userId}/sites`,
            {
              withCredentials: true,
            }
          ),
          axios.get(`${process.env.REACT_APP_API_URL}/discountreason/`, {
            withCredentials: true,
          }),
          axios.get(`${process.env.REACT_APP_API_URL}/worktime/`, {
            withCredentials: true,
          }),
        ]);
      setAvailableViewTypes(viewtype.data);
      setAvailablePaymentMethods(paymentmethod.data);
      setPaymentOptions(paymentmethod.data);
      setAvailableSites(site.data);
      setAvailableWorkTimes(worktimes.data);
      setAvailableDiscountReason([...reasons.data, { reason: "سبب آخر" }]);
      if (role === "Employee") {
        setAvailableUsers([
          {
            id: user.userId,
            name: user.userName,
          },
        ]);
      } else {
        const users = await axios.get(
          `${process.env.REACT_APP_API_URL}/user/all`,
          {
            withCredentials: true,
          }
        );
        setAvailableUsers(users.data);
      }
      setInitialLoading(false);
    } catch (error) {
      setInitialLoading(false);
      toast.error(error.message || "Failed to fetch data");
    }
  }, [user]);
  console.log(rowData)
  useEffect(() => {
    if (location.state === null) {
      navigate("/unauthorized");
    } else {
      setQuantity(rowData.quantity || 0);
      setType(rowData.ViewType.name || "");
      setDate(dayjs(rowData.date) || "");
      setPayment(rowData.PaymentMethod.name || "");
      setUserName(rowData.User.name || "");
      setWorkingTime(rowData.WorkTime?.duration || "");
      // setReceived(rowData.isReceived || false);
      if(rowData.Site.type === "متحرك" ){
        setSite(movingSiteOption.name);
        setMovingSite(rowData.Site.name);
      }
      setDiscounted(rowData.discounted);
      setDiscountPercent(rowData.discountPercentage || 0);
      
      if (rowData.DiscountReason === null && rowData.customReason) {
        setDiscountReason("سبب آخر");
        setCustomReason(rowData.customReason);
      } else {
        setDiscountReason(rowData.DiscountReason?.reason || "");
        setCustomReason(rowData.customReason || "");
      }
      setAmount(
        discounted
          ? Number(rowData.finalAmount / (1 - discountPercent / 100)).toFixed(2)
          : rowData.finalAmount || 0
      );
      setFinalAmount(rowData.finalAmount || 0);
      fetchData();
    }
  }, [fetchData]);
  let movingSites,
    fixedSites = [];
  if (availableSites) {
    movingSites = availableSites.filter((e) => e.type === "متحرك");
    fixedSites = availableSites.filter((e) => e.type === "ثابت");
  }

  function getEntityID(data, entity) {
    const found = data.find((e) => e.name === entity);
    return found ? found : null;
  }
  function getReasonEntity(data, entity) {
    const found = data.find((e) => e.reason === entity);
    return found ? found : null;
  }

  const movingSiteOption = {
    id: "moving",
    name: "موقع متحرك",
  };

  const handleQuantityChange = (e) => {
    const newQuantity = Number(e.target.value) || 1;
    setQuantity(newQuantity);

    if (type && newQuantity) {
      const entity = getEntityID(availableViewTypes || [], type);
      if (entity) {
        const newAmount = entity.defaultPrice * newQuantity;
        setAmount(newAmount);

        // Immediately calculate final amount
        setFinalAmount((prev) =>
          discountPercent
            ? Number(newAmount - newAmount * (discountPercent / 100)).toFixed(2)
            : newAmount
        );
      }
    }
  };

  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    setType(selectedType);
    if (selectedType && quantity) {
      const entity = getEntityID(availableViewTypes || [], selectedType);
      if (entity) {
        const newAmount = entity.defaultPrice * quantity;
        setAmount(newAmount);

        // Immediately calculate final amount
        setFinalAmount((prev) =>
          discountPercent
            ? Number(newAmount - newAmount * (discountPercent / 100)).toFixed(2)
            : newAmount
        );
      }
    }
  };

  // const handleDiscountChange = (e) => {
  //   const percentage = Number(e.target.value) || 0;
  //   if (percentage < 0) {
  //     setDiscountPercent(0);
  //   } else if (percentage > 100) {
  //     setDiscountPercent(100);
  //   } else {
  //     setDiscountPercent(percentage);
  //   }
  //   // Recalculate final amount based on the latest amount
  //   setFinalAmount((prev) =>
  //     amount ? Number(amount - amount * (percentage / 100)).toFixed(2) : prev
  //   );
  // };


  const handleSubmit = async () => {
    const newErrors = {};
    // Validate required fields
    const viewtype = getEntityID(availableViewTypes, type);
    if (!quantity || quantity <= 0)
      newErrors.quantity = "الكمية يجب أن تكون على الأقل واحد.";
    if (!finalAmount || Number(finalAmount) <= 0)
      newErrors.finalAmount = "المبلغ النهائي يجب أن يكون أكبر من 0";
    if (!date) newErrors.date = "التاريخ مطلوب.";
    if (!payment || !getEntityID(availablePaymentMethods, payment))
      newErrors.payment = "طريقة الدفع مطلوبة.";
    if (!site) newErrors.site = "الموقع مطلوب.";
    if (site === movingSiteOption.name && movingSite === "")
      newErrors.movingSite = "يرجى تحديد الموقع المتحرك.";
    if (!type || !getEntityID(availableViewTypes, type))
      newErrors.viewType = "نوع المشاهدات مطلوب.";
    if (discounted) {
      if (
        !discountReason ||
        !getReasonEntity(availableDiscountReason, discountReason)
      )
        newErrors.discountReason = "سبب الخصم مطلوب.";
      if (discountReason === "سبب آخر" && !customReason) {
        newErrors.customReason = "سبب الخصم المخصص مطلوب.";
      }
      if (finalAmount === viewtype?.defaultPrice * quantity) {
        newErrors.finalAmount = "أنت لم تقم بتخفيض المبلغ.";
      }
    }
    // If there are errors, set them and prevent submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    let siteData;
    if (site === movingSiteOption.name) {
      siteData = getEntityID(movingSites, movingSite);
    } else {
      siteData = getEntityID(fixedSites, site);
    }
    // Preparing the entity
    const record = {
      quantity: quantity,
      finalAmount: Number(finalAmount),
      discounted: discounted,
      discountPercentage: discounted ? discountPercent : null,
      DiscountReasonId: discounted
        ? discountReason === "سبب آخر"
          ? null
          : getReasonEntity(availableDiscountReason, discountReason)?.id
        : null,
      customReason: discounted
        ? discountReason === "سبب آخر"
          ? customReason
          : null
        : null,
      date: dayjs(date).format("YYYY-MM-DD"),
      PaymentMethodId: getEntityID(availablePaymentMethods, payment).id,
      SiteId: siteData?.id,
      updatedBy: user.userId,
      UserId: getEntityID(availableUsers, userName).id,
      ViewTypeId: getEntityID(availableViewTypes, type).id,
      WorkTimeId: getEntityByProperty(
        "duration",
        availableWorkTimes,
        workingTime
      ).id,
    };

    try {
      setLoading(true);
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/view/${id}`,
        record,
        {
          withCredentials: true,
        }
      );
      if (res) {
        navigate("/app/views");
        setLoading(false);
        toast.success("تم تعديل المشاهدات بنجاح!");
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
      console.log(error)
    }
  };

  const handleToggleDiscount = () => {
    let defaultPrice;
    if (type && quantity) {
      const entity = getEntityID(availableViewTypes || [], type);
      if (entity) {
        defaultPrice = entity.defaultPrice * quantity;
      }
    }
    if (!discounted === false) {
      setDiscountPercent(0);
      setDiscountReason("");
      setAmount(defaultPrice);
      setFinalAmount(defaultPrice);
      setDiscounted(!discounted);
    } else {
      setDiscounted(!discounted);
    }
  };

  const handleAmount = (e) => {
    let oldAmount = amount;
    let newAmount = e.target.value;
    // let amountToUse;
    const entity = getEntityID(availableViewTypes || [], type);
    const defaultPrice = entity.defaultPrice * quantity;
    if (entity) {
      oldAmount = defaultPrice;
    }
    if (newAmount > oldAmount) {
      return;
    }
    if (!/^\d*\.?\d*$/.test(newAmount)) {
      return;
    } else if (newAmount === ".") {
      return;
    } else if (newAmount === "") {
      // amountToUse = 0;
    } else if (newAmount.endsWith(".")) {
      const dotsCount = newAmount.split(".").length - 1;
      if (dotsCount > 1) {
        return;
      }
      // amountToUse = parseFloat(newAmount).toFixed(3);
    } else if (parseFloat(newAmount) > defaultPrice) {
      newAmount = defaultPrice;
      // amountToUse = parseFloat(newAmount).toFixed(3);
    } else {
      newAmount = Math.floor(parseFloat(newAmount) * 1000) / 1000;
      // amountToUse = parseFloat(newAmount).toFixed(3);
    }
    setAmount(newAmount);
    setFinalAmount(newAmount);
  };

  // Filter PaymentMethods Based on SelectedSite
  const handleSiteChange = (e) => {
    const site = e.target.value
    setSite(site);
    if (site !== movingSiteOption.name) {
      let data = filterPaymentMethods(e.target.value, availablePaymentMethods);
      setPaymentOptions(data);
      setPayment("");
    } else {
      console.log("we're here ")
      setPaymentOptions(availablePaymentMethods);
    }
  };

  console.log(availablePaymentMethods);
  console.log(paymentOptions);

  const handleMovingSiteChange = (e) => {
    setMovingSite(e.target.value);
    let data = filterPaymentMethods(e.target.value, availablePaymentMethods);
    setPaymentOptions(data);
    setPayment("");
  };

  const handleUserChange = (e) => {
    setUserName(e.target.value);
  };
  const handleWorktimeChange = (e) => {
    setWorkingTime(e.target.value);
  };
  const handleCustomWorktime = (e) => {
    let customTime = parseInt(Number(e.target.value) || 1);
    if (customTime <= 0) {
      customTime = 1;
    }
    if (customTime > 24) {
      customTime = 24;
    }
    setCustomTime(customTime);
  };
  return initialLoading ? (
    <Loading />
  ) : (
    <div>
      <div className={styles.form}>
        <div className={styles.container}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              onClick={() => navigate(-1)}
              variant="contained"
              sx={{
                width: "48px",
                height: "48px",
                padding: 0,
                margin: 0,
                minWidth: "auto",
                marginRight: "12px",
              }}
            >
              <ArrowRight size={24} />
            </Button>
            <Typography
              variant="h4"
              color={theme.palette.neutral[900]}
              fontWeight={700}
            >
              تعديل المشاهدات
            </Typography>
          </div>
          <div className={styles.basicDetails}>
            <div className={styles.formSection}>
              <Typography
                variant="h5"
                color={theme.palette.neutral[800]}
                fontWeight={600}
                marginBottom={2}
              >
                المعلومات الأساسية
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={(2, 3)}>
                {/* View Quantity Field */}
                <FormControl
                  fullWidth
                  sx={{ flex: "1 1 45%", minWidth: "250px" }}
                >
                  <TextField
                    fullWidth
                    label="كمية المشاهدات"
                    type="number"
                    value={quantity}
                    onChange={handleQuantityChange}
                    error={!!errors.quantity}
                    helperText={errors.quantity}
                  />
                </FormControl>

                {/* View Type Field */}
                <FormControl
                  fullWidth
                  sx={{ flex: "1 1 45%", minWidth: "250px" }}
                  error={!!errors.viewType}
                >
                  <InputLabel id="view-type-label">نوع المشاهدات</InputLabel>
                  {availableViewTypes.length > 0 && (
                    <Select
                      fullWidth
                      labelId="view-type-label"
                      label="نوع المشاهدات"
                      value={type}
                      onChange={handleTypeChange}
                    >
                      {availableViewTypes.map((type, index) => (
                        <MenuItem key={index} value={type.name}>
                          {type.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  <FormHelperText>{errors.viewType}</FormHelperText>
                </FormControl>
                <FormControl
                  sx={{ flex: "1 1 45%", minWidth: "250px" }}
                  error={!!errors.date}
                >
                  <MobileDatePicker
                    localeText={{
                      clearButtonLabel: "مسح",
                      okButtonLabel: "تم",
                      todayButtonLabel: "اليوم",
                      toolbarTitle: "إختار التاريخ",
                    }}
                    timeZone="UTC"
                    label="التاريخ"
                    format="YYYY/MM/DD"
                    value={date}
                    onChange={(e) => setDate(e)}
                    slotProps={{
                      textField: {
                        error: !!errors.date,
                        InputProps: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <Calendar2Fill />
                            </InputAdornment>
                          ),
                        },
                      },
                      actionBar: {
                        actions: ["today", "clear", "accept"],
                      },
                    }}
                  />
                  <FormHelperText>{errors.date}</FormHelperText>
                </FormControl>
              </Box>
            </div>
            <div className={styles.formSection}>
              <Typography
                variant="h5"
                color={theme.palette.neutral[800]}
                fontWeight={600}
                marginBottom={2}
              >
                المدفوعات والموقع
              </Typography>
              <Box display="flex" flexWrap="wrap" gap={(2, 3)}>
                <FormControl
                  fullWidth
                  sx={{ flex: "1 1 45%", minWidth: "250px" }}
                  error={!!errors.username}
                >
                  <InputLabel id="username-label">إسم المستخدم</InputLabel>
                  <Select
                    fullWidth
                    labelId="username-label"
                    label="إسم المستخدم"
                    value={userName}
                    onChange={handleUserChange}
                    disabled={role === "Employee"}
                  >
                    {availableUsers?.map((u, index) => (
                      <MenuItem key={index} value={u.name}>
                        {u.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.username}</FormHelperText>
                </FormControl>
                <FormControl
                  fullWidth
                  sx={{ flex: "1 1 45%", minWidth: "250px" }}
                  error={!!errors.worktime}
                >
                  <Box sx={{ display: "flex" }}>
                    <InputLabel id="worktime-label">مدة العمل</InputLabel>
                    <Select
                      fullWidth
                      labelId="worktime-label"
                      label="مدة العمل"
                      value={workingTime}
                      onChange={handleWorktimeChange}
                    >
                      {availableWorkTimes?.map((s, index) => (
                        <MenuItem key={index} value={s.duration}>
                          {s.duration}
                        </MenuItem>
                      ))}
                    </Select>
                    {workingTime === "غير ذلك" ? (
                      <TextField
                        sx={{ marginLeft: "12px" }}
                        value={customTime}
                        type="number"
                        error={!!errors.worktime}
                        onChange={handleCustomWorktime}
                        slotProps={{
                          htmlInput: {
                            maxLength: 24,
                          },
                          input: {
                            endAdornment: (
                              <InputAdornment position="end">
                                ساعات
                              </InputAdornment>
                            ),
                          },
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </Box>
                  <FormHelperText>{errors.worktime}</FormHelperText>
                </FormControl>
                {/* View Type Field */}
                <FormControl
                  fullWidth
                  sx={{ flex: "1 1 45%", minWidth: "250px" }}
                  error={!!errors.payment}
                >
                  <InputLabel id="payment-type-label">طريقة الدفع</InputLabel>
                  {paymentOptions.length > 0 && (
                    <Select
                      fullWidth
                      labelId="payment-type-label"
                      label="طريقة الدفع"
                      value={payment}
                      onChange={(e) => setPayment(e.target.value)}
                    >
                      {paymentOptions.map((payment, index) => (
                        <MenuItem key={index} value={payment.name}>
                          {payment.name}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                  <FormHelperText>{errors.payment}</FormHelperText>
                </FormControl>

                <Box
                  sx={{
                    display: "flex",
                    gap: "12px",
                    flex: "1 1 45%",
                    flexDirection: { xs: "column", md: "row" },
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={{ flex: "1 1 45%", minWidth: "250px" }}
                    error={!!errors.site}
                  >
                    <InputLabel id="site-label">الموقع</InputLabel>
                    <Select
                      fullWidth
                      labelId="site-label"
                      label="الموقع"
                      value={site}
                      onChange={handleSiteChange}
                    >
                      {[...fixedSites, movingSiteOption]?.map((s, index) => (
                        <MenuItem key={index} value={s.name}>
                          {s.name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{errors.site}</FormHelperText>
                  </FormControl>
                  {site === movingSiteOption.name && (
                    <FormControl
                      fullWidth
                      sx={{ flex: "1 1 45%", minWidth: "250px" }}
                      error={!!errors.movingSite}
                    >
                      <InputLabel id="site-label">الموقع المتحرك</InputLabel>
                      <Select
                        fullWidth
                        labelId="site-label"
                        label="الموقع المتحرك"
                        value={movingSite}
                        onChange={handleMovingSiteChange}
                      >
                        {movingSites?.map((s, index) => (
                          <MenuItem key={index} value={s.name}>
                            {s.name}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{errors.movingSite}</FormHelperText>
                    </FormControl>
                  )}
                </Box>
              </Box>
            </div>
          </div>

          <div className={styles.formSection}>
            <div
              className={styles.heading}
              style={!discounted ? { margin: "0" } : { marginBottom: "20px" }}
            >
              <Typography
                variant="h5"
                color={theme.palette.neutral[800]}
                fontWeight={600}
              >
                إضافة خصم؟
              </Typography>
              <Switch
                color="primary"
                checked={discounted}
                onClick={handleToggleDiscount}
              />
            </div>
            {discounted && (
              <Box display="flex" flexWrap="wrap" gap={(2, 3)}>
                {/* View Quantity Field */}
                <FormControl
                  fullWidth
                  sx={{ flex: "1 1 45%", minWidth: "250px" }}
                >
                  <TextField
                    fullWidth
                    label="المبلغ الإجمالي"
                    value={amount}
                    error={!!errors.finalAmount}
                    helperText={errors.finalAmount}
                    type="number"
                    onChange={handleAmount}
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  sx={{ flex: "1 1 100%", minWidth: "250px" }}
                  error={!!errors.discountReason}
                >
                  <InputLabel id="site-label">سبب الخصم</InputLabel>
                  <Select
                    fullWidth
                    labelId="site-label"
                    label="سبب الخصم"
                    value={discountReason}
                    onChange={(e) => setDiscountReason(e.target.value)}
                  >
                    {availableDiscountReason.map((e, index) => (
                      <MenuItem key={index} value={e.reason}>
                        {e.reason}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{errors.discountReason}</FormHelperText>
                </FormControl>

                {discountReason === "سبب آخر" ? (
                  <FormControl sx={{ flex: "1 1 45%", minWidth: "250px" }}>
                    <TextField
                      fullWidth
                      label="سبب مخصص"
                      type="text"
                      error={!!errors.customReason}
                      helperText={errors.customReason}
                      multiline={true}
                      rows={4}
                      value={customReason}
                      onChange={(e) => setCustomReason(e.target.value)}
                    />
                  </FormControl>
                ) : (
                  ""
                )}
              </Box>
            )}
          </div>
          <div className={styles.checkout}>
            <div className={styles.totalAmount}>
              <Typography variant="h6" color={theme.palette.neutral[800]}>
                المبلغ الإجمالي
              </Typography>
              <div style={{ display: "flex" }}>
                <Typography
                  variant="h2"
                  color={theme.palette.neutral[900]}
                  fontWeight={700}
                >
                  {finalAmount}
                </Typography>
                <Typography variant="h2" color="primary" fontWeight={700}>
                  د.ك.
                </Typography>
              </div>
              {discounted ? (
                <Typography variant="body2" color={theme.palette.neutral[600]}>
                  With Discount
                </Typography>
              ) : (
                <div> </div>
              )}
            </div>
            <LoadingButton
              loading={loading}
              variant="contained"
              color="primary"
              sx={{ fontSize: "20px" }}
              onClick={handleSubmit}
              fullWidth
            >
              تعديل
            </LoadingButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditView;
